import firebase from '../Firebase/Firebase';

const functions = () => firebase.app().functions('europe-west1');

export const submitVerifiedReview = async (payload) => {
  const callable = functions().httpsCallable('submitVerifiedReview');
  const result = await callable(payload);
  return result.data;
};


export const refreshMyTrust = async () => {
  const callable = functions().httpsCallable('refreshMyTrust');
  const result = await callable({});
  return result.data || {};
};

export const getPublicMemberProfile = async (userId) => {
  if (!userId) throw new Error('Profil introuvable.');
  const callable = functions().httpsCallable('getPublicMemberProfile');
  const result = await callable({ userId });
  return result.data?.profile || null;
};

export const subscribePublishedReviews = ({ revieweeId = '', reviewerId = '' }, onData, onError) => {
  if (!revieweeId && !reviewerId) {
    onData?.([]);
    return () => undefined;
  }

  let cancelled = false;
  const callable = functions().httpsCallable('listPublishedReviews');
  callable({ revieweeId, reviewerId })
    .then((result) => {
      if (!cancelled) onData?.(result.data?.reviews || []);
    })
    .catch((error) => {
      if (!cancelled) onError?.(error);
    });

  return () => { cancelled = true; };
};

export const subscribeProjectReview = ({ demandId, reviewerId }, onData, onError) => {
  if (!demandId || !reviewerId) {
    onData?.(null);
    return () => undefined;
  }

  return firebase.firestore().collection('demands').doc(demandId)
    .collection('reviews').doc(reviewerId).onSnapshot(
    (snapshot) => onData?.(snapshot.exists ? { id: snapshot.id, ...snapshot.data() } : null),
    (error) => onError?.(error),
  );
};
